import { Facebook, Instagram } from "lucide-react";
import { FACEBOOK_URL, INSTAGRAM_URL } from "@/data/content";

export const FollowJourneyPill = () => (
  <div
    data-testid="mission-social-btn"
    className="inline-flex items-stretch rounded-full overflow-hidden bg-white/70 border-2 border-[#111111]/15 shadow-lg hover:scale-105 transition-transform"
  >
    <span className="flex items-center px-7 py-3 sm:py-4 text-[#111111] font-bold text-lg whitespace-nowrap">
      Follow Our Journey
    </span>
    <div className="w-px self-stretch bg-[#111111]/15" />
    <a
      data-testid="mission-facebook-link"
      href={FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Bobo's on Facebook"
      className="flex items-center justify-center px-6 py-3 sm:py-4 text-[#111111] hover:bg-[#1877F2] hover:text-white transition-colors"
    >
      <Facebook className="h-6 w-6" />
    </a>
    <div className="w-px self-stretch bg-[#111111]/15" />
    <a
      data-testid="mission-instagram-link"
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Bobo's on Instagram"
      className="flex items-center justify-center px-6 py-3 sm:py-4 text-[#111111] hover:text-white hover:bg-[linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)] transition-colors"
    >
      <Instagram className="h-6 w-6" />
    </a>
  </div>
);
